import React, {useEffect, useState} from 'react';
import TakisHero from "../components/TakisHero"
import TakisHeroSkeleton from "../components/Skeletons/TakisHeroSkeleton"
import TakisFreeTextSkeleton from "../components/Skeletons/TakisFreeTextSkeleton"
import TakisGridSkeleton from "../components/Skeletons/TakisGridSkeleton"
import TakisRecipeListSkeleton from "../components/Skeletons/TakisRecipeListSkeleton"
import TakisSocialSkeleton from "../components/Skeletons/TakisSocialSkeleton"
import useHomepageData from '../hooks/useHomepageData';
import TakisFreeText from '../components/TakisFreeText';
import TakisGrid from '../components/TakisGrid';
import TakisSocial from '../components/TakisSocial';
import TakisRecipeList from '../components/TakisRecipeList';

const Home = () => {
  const [homepageData, setHomepageData] = useState('');
  const [homepageRecipesData, setHomepageRecipesData] = useState('');
  const { error, isLoading, homeData } = useHomepageData();

  useEffect(() => {
    if (homeData) {
      setHomepageData(homeData);
    }
  }, [homeData]);

  useEffect(() => {
    if (homepageRecipesData) {
      setHomepageRecipesData(homepageRecipesData);

    }
  }, [homepageRecipesData]);

  if (isLoading || error || !homepageData) {
    return (
      <>
        <TakisHeroSkeleton/>
        <TakisFreeTextSkeleton/>
        <TakisGridSkeleton/>
        <TakisSocialSkeleton/>
        <TakisRecipeListSkeleton totalRecipes={2} hideLoadMore={true}/>
      </>
    );
  }

  return (
    <>
      <TakisHero
        data={homepageData.hero}
      />
      <TakisFreeText
        title={homepageData.freeText.title}
        paragraphsFirstColumn={homepageData.freeText.paragraphsFirstColumn}
        paragraphsSecondColumn={homepageData.freeText.paragraphsSecondColumn}
        ctas={homepageData.freeText.ctas}
        isSectionTitle={true}
      />
      <TakisGrid
        title={homepageData.gridCategory.title}
        items={homepageData.gridCategory.items}
        itemsSize="wide"
        marginType={1}
      />
      <TakisSocial data={homepageData.social}/>
      <TakisRecipeList
        pageType={'Recipes'}
        title={homepageData.recipesComponent.title}
        recipeCTA={homepageData.recipesComponent.recipeCTA}
        recipesPageCTA={homepageData.recipesComponent.recipesPageCTA}
        initialRecipes={homepageData.recipesSection.recipes}
        isStatic={true}
      />
    </>
  );
};

export default Home;
